import { combineReducers } from "redux";
import { ActionType } from "typesafe-actions";

import { ownedBetsActions } from "./actions";

import {
  OWNED_BETS_FAILURE,
  OWNED_BETS_REQUEST,
  OWNED_BETS_SUCCESS,
} from "../../constants/ownedBets";
import { UnlockedTipData } from "../tips/reducer";

export type OwnedBetsState = {
  requested: boolean;
  data: {
    open: { tips: UnlockedTipData[]; matches: any };
    closed: { tips: UnlockedTipData[]; matches: any };
  };
  isLoading: boolean;
  error: string | null;
};
export type OwnedBetsActions = ActionType<typeof ownedBetsActions>;

export const ownedBetsReducer = combineReducers<
  OwnedBetsState,
  OwnedBetsActions
>({
  requested: (state = false, action: any) => {
    switch (action.type) {
      case OWNED_BETS_REQUEST:
        return true;
      default:
        return state;
    }
  },
  data: (
    state = {
      open: { tips: [], matches: [] },
      closed: { tips: [], matches: [] },
    },
    action: any
  ) => {
    switch (action.type) {
      case OWNED_BETS_SUCCESS:
        switch (action.payload.openstatus) {
          case "closed":
            return {
              open: state.open,
              closed: {
                tips: action.payload.data.tips,
                matches: action.payload.data.matches,
              },
            };
          case "open":
            return {
              open: {
                tips: action.payload.data.tips,
                matches: action.payload.data.matches,
              },
              closed: state.closed,
            };
          default:
            return {
              open: state.open,
              closed: {
                tips: [...state.closed.tips, ...action.payload.data.tips],
                matches: [
                  ...state.closed.matches,
                  ...action.payload.data.matches,
                ],
              },
            };
        }

      default:
        return state;
    }
  },
  isLoading: (state = false, action: any) => {
    switch (action.type) {
      case OWNED_BETS_REQUEST:
        return true;
      default:
        return false;
    }
  },
  error: (state = null, action: any) => {
    switch (action.type) {
      case OWNED_BETS_FAILURE:
        return action.payload.message || action.payload.detail;
      default:
        return null;
    }
  },
});
